import React from 'react';
import styles from './Inline.scss.js';

const Inline = function Inline({
  align = 'start',
  blockAlign = 'center',
  spacing = '4',
  wrap = true,
  children
}) {
  const style = {
    '--pc-inline-align': align,
    '--pc-inline-block-align': blockAlign,
    '--pc-inline-wrap': wrap ? 'wrap' : 'nowrap',
    '--pc-inline-spacing': `var(--p-space-${spacing})`
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles.Inline,
    style: style
  }, children);
};

export { Inline };
